export const colors = {
  primary: 'rgba(0, 128, 255, 1)',
  secondary: 'rgba(0, 128, 255, 0.5)',
  red: '#cc1034',
  grey: '#6c757d',
  grey_2: '#555',
  white: '#FFFFFF',
};
